import { Tooltip } from '@shape-ds/components';
import { Action, type ActionStatus } from 'queries/cases/types';
import './ActionStatusCell.scss';
import {
  getDisplayText,
  getStatusCounts,
  getTooltipText,
} from '../../helpers/ActionStatusCell.helper';

interface Props {
  actions: Action[];
  actionStatus: ActionStatus;
}

export const ActionStatusCell = ({ actions, actionStatus }: Props) => {
  const counts = getStatusCounts(actions);
  const displayText = getDisplayText(actionStatus);
  const tooltipText = getTooltipText(counts);

  return (
    <Tooltip title={tooltipText} className="tooltip-action-status" followCursor={false}>
      <div className={actionStatus}>{displayText}</div>
    </Tooltip>
  );
};
